// extracted by mini-css-extract-plugin
export var avatar = "Discussion-module--avatar--eKBjE";
export var btnArrowWrapper = "Discussion-module--btnArrowWrapper--KYZtZ";
export var btnText = "Discussion-module--btnText--weSo5";
export var button = "Discussion-module--button--ljrVq";
export var commentsErrorWrapper = "Discussion-module--commentsErrorWrapper--OdShh";
export var commentsErrorWrapperMain = "Discussion-module--commentsErrorWrapperMain--hPBKh";
export var counter = "Discussion-module--counter--XKdfK";
export var discussion_wrapper = "Discussion-module--discussion_wrapper--bUGdD";
export var discussion_wrapper_sub = "Discussion-module--discussion_wrapper_sub--sZcAR";
export var inputWrap = "Discussion-module--inputWrap--TdJeY";
export var limitErrorMessage = "Discussion-module--limitErrorMessage--Xr12Z";
export var tArea = "Discussion-module--tArea--5H-fu";
export var title = "Discussion-module--title--SGmT5";
export var wrapper = "Discussion-module--wrapper--zPT5P";